import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../utils/scrollTop";

function Cookies() {
  const navigate = useNavigate();
  return (
    <>
    <ScrollToTop/>
    {/* <TopBar/> */}
    <div>
      <br />
      <br />
      <p className="head">COOKIE POLICY</p>
      <div className="intro">
        <p>Cookies are created when you visit a website or use an app. They are small files that are stored on your device and used to customise your experience.
When you access taost.io for the first time, you will be asked to set your cookie preferences for the site.
</p>
<p>To help you make your choices this notice explains how we use cookies and similar technologies to collect information when you access our services and how we use that information. We also explain when and how you can manage your cookie preferences.</p>
<p>We use cookies to make your use of our sites and apps quicker, easier and more relevant to you. If you don’t turn these cookies on it may affect your browsing experience. To avoid impacting your browsing experience cookies need to be enabled in your browser settings.</p>
<h4>
What do we use cookies for?
</h4>
<p>Essential Cookies:</p>
<p>These cookies are needed to provide the content, product or service you have asked for. We use essential cookies for the following purposes:<br></br>
•	Enabling you to stream content properly<br></br>
•	Make sure our website is working properly<br></br>
•	Remembering if you’ve been to the site or app before<br></br>
•	Enabling features of our service.<br></br>
</p>
<p>Performance cookies:</p>
<p>We use cookies to help improve our website. For example:</p>
<p>•	To keep track of what pages, content and links are popular and which ones don’t get used.<br></br>
•	To see how users navigate through our sites, when error messages appear and what caused them.<br></br>
•	The information collected using these cookies is grouped with the information from everyone else so we can see overall patterns rather than individual activity. When given the option, we recommend you turn on cookies used for these purposes.
</p>
<p>Other ways to manage your cookie preferences</p>
<p>
Most modern browsers allow you to see what cookies you have on your device and to clear them all or individually. To find out how to do this, go to aboutcookies.org, which contains comprehensive information on how to do this on a variety of browsers.
</p>
<p>Please remember that any settings you change will not just affect the cookies we use. The changes will apply to all websites you visit unless you choose to block cookies only from specific sites.</p>
<p>
Deleting cookies means that settings you have made on a site or app will be lost. If you’ve set your preferences to opt out of cookies, this setting will be lost too if that information is stored in a cookie. Blocking all cookies means functionality on our sites and apps may be lost. Therefore, we don’t recommend turning all cookies off when using our sites and apps.
</p>
<h4>Changes to this notice</h4>
<p>
We will occasionally update our Privacy and Cookies Notice. We will post a notice of any material changes on our website prior to implementing the changes, and, where appropriate, notify you using any of the contact details we hold for you for this purpose. We encourage you to periodically review this Notice to be informed of how we use your information.  
</p>
<h4>
This Privacy and Cookies Notice was last updated on 26th September 2022.
</h4>
      </div>
    </div>
   
<Button variant={'contained'} onClick={()=>navigate(-1)}>Go back</Button>
    </>
  );
}

export default Cookies;